type ParsedContent = {
  message: string;
  verses: Record<string, any>;
  questions?: string[];
};

export function parseMessageContent(content: string): ParsedContent {
  if (!content) {
    return { message: '', verses: {}, questions: [] };
  }

  try {
    if (content.trim().startsWith('{') && content.trim().endsWith('}')) {
      const parsed = JSON.parse(content);
      
      if (parsed.questions) {
        return {
          message: '',
          verses: {},
          questions: parsed.questions
        };
      }

      const processedVerses: Record<string, any> = {};
      
      Object.entries(parsed.verses || {}).forEach(([bookName, verse]: [string, any]) => {
        const formattedBook = bookName
          .replace(/_/g, ' ')
          .replace(/(\d+)/, '$1 ')
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
          .join(' ');

        processedVerses[bookName] = {
          ...verse,
          book: formattedBook
        };
      });

      return {
        message: parsed.message?.replace(/\\n/g, '\n') || '',
        verses: processedVerses,
        questions: []
      };
    }
    
    return {
      message: content,
      verses: {},
      questions: []
    };
  } catch (error) {
    console.error('Error parsing message content:', error);
    return {
      message: content,
      verses: {},
      questions: []
    };
  }
}
